<mat-form-field class="select-date-type" appearance="outline">
  <mat-label>{{ label }}</mat-label>
  <mat-select class="select-date-type__option-change" [formControl]="control" [required]="required">
    <mat-option *ngFor="let option of options" [value]="option.value">
      {{ option.text }}
    </mat-option>
  </mat-select>
</mat-form-field>
